import { render } from "./GanttGridTaskBar.vue?vue&type=template&id=0b15abb9"
import script from "./GanttGridTaskBar.vue?vue&type=script&lang=ts"
export * from "./GanttGridTaskBar.vue?vue&type=script&lang=ts"
script.render = render

export default script